import { Component, OnInit, Input, OnDestroy, OnChanges  } from '@angular/core';
import { Client } from 'src/app/entity/exhibitor';
import { ProspectService } from 'src/app/service/prospect.service';
import { Prospect, Secteur, Pays } from 'src/app/entity/prospect';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientService } from 'src/app/service/client.service';
import { ExhibitorService } from 'src/app/service/exhibitor.service';
import { Subscription, Observable } from 'rxjs';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { SecteurService } from 'src/app/service/secteur.service';

@Component({
  selector: 'app-personel-client',
  templateUrl: './personel-client.component.html',
  styleUrls: ['./personel-client.component.css']
})
export class PersonelClientComponent implements OnInit, OnChanges {





  
  ngOnChanges(changes: import("@angular/core").SimpleChanges): void {
    if(this.selectedClient) 
       this.prospectService.getProspectErp(this.selectedClient.prospectId.prospectId).subscribe(result=>{
         this.selectedProspect=this.selectedClient.prospectId;
        /* this.buildPersonalForm();
         this.onChanges()
         this.onPaysChanges()*/
             })
    
  }


@Input()selectedClient:Client;
personalForm:  FormGroup;
selectedProspect:Prospect;
 
secteurs:Observable<Secteur[]>;
payss:Observable<Pays[]>;


  constructor(private prospectService: ProspectService,private fb:FormBuilder,private router:Router,
    private activatedRoute:ActivatedRoute,private clientService:ExhibitorService,
    private secteurService:SecteurService
    ) {
   
   
   }

  ngOnInit() {
   
    this.secteurs=this.secteurService.getAll()
 
    }
    clickedMe(){
      this.router.navigateByUrl(`/add-exhibitor/${this.selectedClient.idClient}/0`  )  
  
    }
   /* onChanges(): void {


      this.personalForm.controls.secteurActivite.valueChanges.subscribe(val => {
  
        if (val) {
          const vals = val + "";
          if (vals.length > 0)
            this.secteurs = this.secteurService.findSecteurbydesignation(val);
  
  
        }
      });
    }
    onPaysChanges(): void {


      this.personalForm.controls.paysActivite.valueChanges.subscribe(val => {
  
        if (val) {
          const vals = val + "";
          if (vals.length > 0)
            this.payss = this.prospectService.findPaysByDesignation(val);
  
  
        }
      });
    }


  buildPersonalForm(): void {

    this.personalForm = this.fb.group({
        'raisonSocial': [this.selectedProspect.raisonSocial, Validators.required],
        'nrc': [this.selectedProspect.nrc, Validators.required],
        'nif': [this.selectedProspect.nif, [Validators.required]],
        'nai': [this.selectedProspect.nai, [Validators.required]],
        'vatNumber': [this.selectedProspect.vatNumber,  ],
        'secteurActivite': [this.selectedProspect.secteurId, [Validators.required]],
        'paysActivite': [this.selectedProspect.paysId, [Validators.required]]
    });
}


displaySecteurFn(secteur?: Secteur): string | undefined {
  return secteur ? secteur.designation : "";
}
displayPaysFn(pays?: Pays): string | undefined {
  return pays ? pays.designationFr : "";
}
 */
}
